/* Lurelle product page behaviour: bundle cards drive Dawn's variant picker, hero video autoplays muted,
   sticky add-to-cart on phones, subtle reveal on scroll. No dependencies beyond Dawn's pubsub. */
(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (Number(cents) / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    var f = format || '${{amount}}';
    return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0]).replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  var sticky = null;

  function updateSticky(variant) {
    if (!sticky || !variant) return;
    var t = sticky.querySelector('[data-lx-sticky-title]');
    var p = sticky.querySelector('[data-lx-sticky-price]');
    if (t) t.textContent = variant.title;
    if (p) p.textContent = formatMoney(variant.price, sticky.dataset.moneyFormat);
    var btn = sticky.querySelector('[data-lx-sticky-add]');
    if (btn) {
      btn.disabled = variant.available === false;
      btn.textContent = variant.available === false ? 'Sold out' : 'Add to cart';
    }
  }

  function selectVariantByValue(sectionId, value) {
    var vs = (sectionId && document.querySelector('variant-selects[data-section="' + sectionId + '"]')) || document.querySelector('variant-selects');
    if (!vs) return false;
    var inputs = Array.prototype.slice.call(vs.querySelectorAll('input[type="radio"], select option'));
    var input = inputs.filter(function (el) { return el.value === value; })[0];
    if (!input) return false;
    if (input.tagName === 'OPTION') {
      var sel = input.closest('select');
      if (sel && sel.value !== input.value) {
        sel.value = input.value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return true;
    }
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  // Slide the gallery to the still for the chosen bundle without reordering Dawn's media list
  // (so the hero video stays first). Toggling is-active covers desktop thumbnail layouts; scrollTo covers phones.
  function showBundleMedia(card) {
    var id = card && card.dataset.lxMedia;
    if (!id) return;
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var slide = gallery.querySelector('[data-media-id="' + id + '"]');
    if (!slide) return;
    var list = slide.parentElement;
    Array.prototype.forEach.call(list.querySelectorAll('[data-media-id]'), function (el) {
      el.classList.toggle('is-active', el === slide);
    });
    // Smooth only while the gallery is on screen; an off-screen smooth scroll can lag by seconds on phones.
    var onScreen = gallery.getBoundingClientRect().bottom > 0;
    if (typeof list.scrollTo === 'function') list.scrollTo({ left: slide.offsetLeft, behavior: onScreen ? 'smooth' : 'auto' });
    var thumb = gallery.querySelector('[data-target="' + id + '"]');
    if (thumb && typeof gallery.setActiveThumbnail === 'function') gallery.setActiveThumbnail(thumb);
  }

  // Countdown to today's order cutoff in the store's time zone. The promise is "ships within 1 business day",
  // so after the cutoff (or on a weekend) the clock simply targets the next business day's cutoff.
  function initCutoff() {
    var els = document.querySelectorAll('[data-lx-cutoff]');
    if (!els.length) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var partsIn = function (date, tz) {
      var f = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, weekday: 'short', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var o = {};
      f.formatToParts(date).forEach(function (p) { o[p.type] = p.value; });
      return o;
    };
    function tick() {
      var now = new Date();
      Array.prototype.forEach.call(els, function (el) {
        var tz = el.dataset.tz || 'America/New_York';
        var hour = parseInt(el.dataset.hour || '14', 10);
        var p;
        try { p = partsIn(now, tz); } catch (e) { el.textContent = ''; return; }
        var h = parseInt(p.hour, 10) % 24, m = parseInt(p.minute, 10), sec = parseInt(p.second, 10);
        var secsNow = h * 3600 + m * 60 + sec;
        var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
        var daysAhead = 0;
        var target = hour * 3600;
        if (secsNow >= target || day === 0 || day === 6) {
          daysAhead = 1;
          var d = (day + 1) % 7;
          while (d === 0 || d === 6) { daysAhead++; d = (d + 1) % 7; }
        }
        var left = daysAhead * 86400 + target - secsNow;
        var hh = Math.floor(left / 3600), mm = Math.floor((left % 3600) / 60), ss = left % 60;
        el.textContent = (hh > 23 ? Math.floor(hh / 24) + 'd ' : '') + pad(hh % 24) + ':' + pad(mm) + ':' + pad(ss);
      });
      setTimeout(tick, 1000);
    }
    tick();
  }

  function initBundles() {
    var wraps = document.querySelectorAll('[data-lx-bundles]');
    Array.prototype.forEach.call(wraps, function (wrap) {
      var sectionId = wrap.dataset.section;
      var cards = Array.prototype.slice.call(wrap.querySelectorAll('[data-lx-card]'));
      var mark = function (card) {
        cards.forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-selected', on);
          c.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      };
      cards.forEach(function (card) {
        card.addEventListener('click', function () {
          mark(card);
          selectVariantByValue(sectionId, card.dataset.lxValue);
          showBundleMedia(card);
        });
      });
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
          var v = payload && payload.data && payload.data.variant;
          if (!v) return;
          var card = cards.filter(function (c) { return String(c.dataset.lxVariant) === String(v.id); })[0];
          if (card) {
            mark(card);
            showBundleMedia(card);
          }
          updateSticky(v);
        });
      }
      // "Select" links elsewhere on the page (coverage table) pick a card without a reload.
      document.addEventListener('click', function (e) {
        var a = e.target.closest && e.target.closest('[data-lx-select-variant]');
        if (!a) return;
        var card = cards.filter(function (c) { return String(c.dataset.lxVariant) === String(a.dataset.lxSelectVariant); })[0];
        if (!card) return;
        e.preventDefault();
        card.click();
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initSticky() {
    sticky = document.querySelector('[data-lx-sticky]');
    if (!sticky) return;
    var add = sticky.querySelector('[data-lx-sticky-add]');
    if (add) {
      add.addEventListener('click', function () {
        var btn = document.querySelector('product-form [id^="ProductSubmitButton-"]');
        if (btn) {
          btn.click();
        } else {
          var bundles = document.querySelector('[data-lx-bundles]');
          if (bundles) bundles.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      });
    }
    var anchor = document.querySelector('product-form') || document.querySelector('[data-lx-bundles]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        document.body.classList.toggle('lx-has-sticky', past);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  function initHeroVideo() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var first = gallery.querySelector('.product__media-item');
    if (!first) return;
    var dm = first.querySelector('deferred-media');
    if (!dm) return;
    var tpl = dm.querySelector('template');
    if (!tpl || !tpl.content || !tpl.content.querySelector('video')) return;
    first.classList.add('lx-hero-video');
    var start = function () {
      if (!dm.getAttribute('loaded') && typeof dm.loadContent === 'function') dm.loadContent(false);
      var v = dm.querySelector('video');
      if (!v) return;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.loop = true;
      v.controls = false;
      v.removeAttribute('controls');
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
      if (!dm.querySelector('.lx-unmute')) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lx-unmute';
        b.setAttribute('aria-label', 'Play with sound');
        b.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M11 5 6 9H2v6h4l5 4z"/><path d="M19 12a7 7 0 0 0-3-5.7M15.5 9.5a3 3 0 0 1 0 5"/></svg><span>Tap for sound</span>';
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          v.muted = false;
          v.controls = true;
          v.currentTime = 0;
          var pp = v.play();
          if (pp && pp.catch) pp.catch(function () {});
          b.remove();
        });
        dm.appendChild(b);
      }
    };
    // customElements may define deferred-media after this script runs
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('deferred-media').then(start, start);
    } else {
      start();
    }
  }

  function initReveal() {
    var els = document.querySelectorAll('.lx-reveal');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  function init() {
    initBundles();
    initSticky();
    initHeroVideo();
    initReveal();
    initCutoff();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
